import { PortalType } from "@studyportals/domain-client";
import { DurationFilterOptionValue} from '@studyportals/search-filters/server-side';

export const DURATION_FILTER_BUCKETS: Record<string, DurationFilterOptionValue[]> = {
	[PortalType.BACHELOR]: [
		DurationFilterOptionValue.ONE_YEAR,
		DurationFilterOptionValue.LESS_THAN_TWO_YEARS,
		DurationFilterOptionValue.TWO_YEARS,
		DurationFilterOptionValue.TWO_AND_A_HALF_YEARS,
		DurationFilterOptionValue.THREE_YEARS,
		DurationFilterOptionValue.THREE_AND_A_HALF_YEARS,
		DurationFilterOptionValue.FOUR_YEARS,
		DurationFilterOptionValue.MORE_THAN_FOUR_YEARS
	],
	[PortalType.MASTER]: [
		DurationFilterOptionValue.LESS_THAN_ONE_YEAR,
		DurationFilterOptionValue.ONE_YEAR,
		DurationFilterOptionValue.ONE_AND_A_HALF_YEARS,
		DurationFilterOptionValue.TWO_YEARS,
		DurationFilterOptionValue.MORE_THAN_TWO_YEARS
	],
	[PortalType.PHD]: [
		DurationFilterOptionValue.ONE_YEAR,
		DurationFilterOptionValue.LESS_THAN_TWO_YEARS,
		DurationFilterOptionValue.TWO_YEARS,
		DurationFilterOptionValue.TWO_AND_A_HALF_YEARS,
		DurationFilterOptionValue.THREE_YEARS,
		DurationFilterOptionValue.THREE_AND_A_HALF_YEARS,
		DurationFilterOptionValue.FOUR_YEARS,
		DurationFilterOptionValue.MORE_THAN_FOUR_YEARS
	],
	[PortalType.DISTANCE_LEARNING]: [
		DurationFilterOptionValue.LESS_THAN_ONE_YEAR,
		DurationFilterOptionValue.ONE_YEAR,
		DurationFilterOptionValue.ONE_AND_A_HALF_YEARS,
		DurationFilterOptionValue.TWO_YEARS,
		DurationFilterOptionValue.TWO_AND_A_HALF_YEARS,
		DurationFilterOptionValue.THREE_YEARS,
		DurationFilterOptionValue.THREE_AND_A_HALF_YEARS,
		DurationFilterOptionValue.FOUR_YEARS,
		DurationFilterOptionValue.MORE_THAN_FOUR_YEARS
	],
	[PortalType.SHORT]: [
		DurationFilterOptionValue.LESS_THAN_ONE_MONTH,
		DurationFilterOptionValue.ONE_TO_THREE_MONTHS,
		DurationFilterOptionValue.MORE_THAN_THREE_MONTHS
	]
}
